export const STATE_LAW_API = "v1/state-law-block";
export const STATE_API = "v1/states";
